import { call, put, takeLatest } from 'redux-saga/effects'
import { ViewerRequestActions, ViewerRequestTypes } from './viewerRequestSlice'
import api from '../../services/api'

function* createViewerRequestSaga(action) {
  const response = yield call(api.createViewerRequest, action.data)
  if (response.ok) {
    yield put(ViewerRequestActions.createViewerRequestSuccess())
  } else {
    const error = response.data?.message || response.data?.error || response.problem
    yield put(ViewerRequestActions.createViewerRequestFailure(error))
  }
}

function* fetchViewerRequestsSaga(action) {
  const response = yield call(api.getViewerRequests, action.options)
  if (response.ok) {
    yield put(ViewerRequestActions.fetchViewerRequestsSuccess(response.data))
  } else {
    const error = response.data?.message || response.data?.error || response.problem
    yield put(ViewerRequestActions.fetchViewerRequestsFailure(error))
  }
}

export default function* viewerRequestSaga() {
  yield takeLatest(ViewerRequestTypes.CREATE_VIEWER_REQUEST, createViewerRequestSaga)
  yield takeLatest(ViewerRequestTypes.FETCH_VIEWER_REQUESTS, fetchViewerRequestsSaga)
}
